export default __webpack_public_path__ + "static/mises-b5fe9d5926274a256681de2bc967038f.png";